import React from "react";
import Navbar from "./Navbar";
import SideBar from "./SideBar";

function Header({ roles, openModal, colourBlindMode, onColourBlindMode, offColourBlindMode }) {
    return (
        <div>
            <Navbar
                roles={roles}
                openModal={openModal}
                colourBlindMode={colourBlindMode}
                onColourBlindMode={onColourBlindMode} 
                offColourBlindMode={offColourBlindMode}
            />
            <SideBar />
        </div>
    );
}

export default Header;
